import React, { JSX } from 'react';
import {
  Field,
  ImageField,
  LinkField,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ItemValue } from 'components/types/ListItem';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';
import TimelineChild from './TimelineChild';

type TimelineChild = {
  id: string;
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseSummary: RichTextField;
    BaseImage: ImageField;
    BaseImageRight: {
      value: boolean;
    };
    BaseDate: Field<string>;
    BaseLocation: Field<string>;
    BaseHeading: Field<string>;
    BaseLink: LinkField;
    BaseLinkType: ItemValue;
  };
};

type TimelineChildComponentProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    articlesummaries: Array<TimelineChild>;
  };
};

const TimelineParent = (props: TimelineChildComponentProps): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;
  const innerFields = fields;

  return (
    <div
      className={classNames('mx-0 row overhauled bg-secondary', marginSize)}
      id={`timeline-parent article-summary-component-${props.rendering?.uid}`}
    >
      <div className={`${'article-summary-wrapper timeline-parent'}`}>
        <div className="jss-inner-container">
          <div className={`${'article-summaries'}`}>
            {innerFields?.articlesummaries?.map(({ id, fields }, index) => {
              return (
                <div key={id} className={`${'article-summary-outer'}`}>
                  <TimelineChild
                    id={id}
                    summary={fields?.BaseSummary}
                    image={fields?.BaseImage}
                    imageRight={fields?.BaseImageRight?.value}
                    date={fields?.BaseDate?.value}
                    location={fields?.BaseLocation?.value}
                    heading={fields?.BaseHeading?.value}
                    link={fields?.BaseLink}
                    linkType={fields?.BaseLinkType?.name}
                    imgAlt={`articles_image_${index + 1}`}
                    marginSize={fields?.MarginSize?.fields?.heading?.value}
                    last={index === innerFields.articlesummaries.length - 1}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineParent;
